import { DSIcon, Breadcrumb } from '../common/atoms';
import React, { Component } from 'react';
import _ from 'lodash';
import { Row, Tabs, Col, Card, Avatar, notification, Spin, List, message, Progress, Tag, Tooltip} from 'antd';
import Highstock from 'highcharts/highstock';
import ReactHighcharts from 'react-highcharts';
import { withDsChartTheme } from './../../utils/chartTheme';
import {WellnessScoreMainImage,HeartBeatImage,LeftChevronIcon,StarImage,WellnessScoreImage} from '../../assets/images';
import { utilizationApi } from '../../services';
import { ContractsManager } from '../../managers';
import handleAppError from '../handlers/handleAppError'
import { MetricManager as HraMetricManager} from '../../managers/HRAManager';

const Charts = withDsChartTheme(ReactHighcharts.withHighcharts(Highstock));
const { Meta } = Card;
const TabPane = Tabs.TabPane;

class CompanyWellnessScore extends Component {
  constructor(props) {
      super(props);
      this.state = {
        contractObj: null,
        contractId: null,
        loading: false,
        data: {},
        employeeCountOverall: {filters:[], config: {}},
        baseConfig : {
          filters: [],
          config: {
            chart: {},
            title: {text: '', align: 'left'},
            subtitle: { text: '', align: 'left' },
            xAxis: {},
            yAxis: {},
            credits: {
              enabled: false
            },
            series: []
          }
        }
      };
  }

  componentDidMount () {
    let that = this;
    this.setState({loading: true})
    window.axios.get(window.API_URL + 'corporate/wellness-score')
      .then(function (response) {
        console.log("CompanyWellnessScore -> componentDidMount -> response", response)
        that.setState({
                       loading: false,
                       data: response.data})
      })
      .catch(function (error) {
        that.setState({loading: false})
        notification['error']({
        message: 'Something Went Wrong',
        description: "Please try again later"
        })
        console.log(error);
      })
      this.fetchContractDetails();
  }

  fetchContractDetails = () => {
    utilizationApi.fetchContracts(
      {},
      (resp) => {
        var contractObj = new ContractsManager(resp.data, 'HEALTH_CHECKS');
        this.setState({
          contractObj,
          selectedContractObj: contractObj.formattedData[0],
          contractId: contractObj.formattedData[0].contract_id,
          overallId: contractObj.formattedData[0].contract_id,
          loading: true
        }, () => {
            this.fetchHraData()
        });

      },
      (err) => {
        handleAppError(err);
      }
    );
  };

  fetchHraData = () => {
    const {contractId} = this.state
    utilizationApi.hraFetchMetrics({ contractId, startDate: this.state?.selectedContractObj?.start_date, endDate: this.state?.selectedContractObj?.end_date })
      .then((resp) => {
        var hraMetricObj = new HraMetricManager(resp.data);
        console.log("CompanyWellnessScore -> fetchHraData -> hraMetricObj", hraMetricObj)
        this.setState({ hraMetricObj });
        this.setState({ loading: false });
      })
      .catch((err) => handleAppError(err));
  }

  getColor(value){
    let color = '#E5E7EB'
    if (value === 'Active') {
      color = '#2563EB'
    }else if(value === 'GoalColor'){
      color = '#EFF6FF'
    }else if(value === 'PoorColor'){
      color = '#FDEDEB'
    }else if(value === 'AverageColor'){
      color = '#FDF1E4'
    }else if(value === 'GoodColor'){
      color = '#E6F3F0'
    }
    return color
  }

  renderOverview(){
    sessionStorage.setItem('defaultSelectedTab', '9')
    this.props.history.push({pathname: '/overview'})
  }

  renderWellnessScoreTrendChart(){
    let that = this
    let keys = Object.keys(that.state.data.hra_trends)
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    let series = Object.values(that.state.data.hra_trends)
    let yinterval = (parseInt(that.state.data.goal_score)/5).toFixed(0)
    baseConfig.config.chart.type = 'line'
    baseConfig.config.yAxis.title = {text: "Wellness Score"}
    baseConfig.config.xAxis = {categories: keys
                              }
    baseConfig.config.plotOptions = {line: {dataLabels: { enabled: true},enableMouseTracking: true,events: {
            legendItemClick: function () {
                return false;
            }
        }}}
    baseConfig.config.series = [{name: 'Current Score',data: series.map(Number),color: '#2563EB'}]
    return(
      <div>
        <Row>
          <Col span={12}>
            <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 60}}>
              <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 0}}>COMPANY WELLNESS SCORE TREND</h4>
            </Row>
          </Col>
        </Row>
        <Card className="health-check-utilization-card" style={{marginBottom: 20,marginTop: 10}}>
          <Row type="flex" justify="end" style={{marginLeft: 0,marginBottom: 20}}>
            <h6 style={{color: '#6B7280',fontSize: 14}}>The Company wellness score is spread across <span className="semibold" style={{color: '#475569'}}>last 6 months </span></h6>
          </Row>
          <Charts
          filters={this.state.employeeCountOverall.filters}
          config={baseConfig.config}/>
        </Card>
      </div>
    )
  }

  renderIndustryWise(){
    let that = this
    let industry_wise_series = that.state.data.industry_wise_series
    let industry_wise_keys = that.state.data.industry_wise_keys
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    baseConfig.config.chart.type = 'column'
    baseConfig.config.yAxis.title = {text: "Current Score"}
    baseConfig.config.xAxis = {categories: industry_wise_keys
                              }

    baseConfig.config.series = [{name: 'Industry Based',data: industry_wise_series,color: 'white',states: {
                hover: {
                    enabled: false
                }
            }}]
    baseConfig.config.plotOptions = {column: {maxPointWidth: 21,events: {
            legendItemClick: function () {
                return false;
            }
        }}}
    return(
      <div>
        <Row>
          <Col span={12} >
            <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 60}}>
              <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 0}}>INDUSTRY WISE</h4>
            </Row>
            <Card className="health-check-utilization-card" style={{marginBottom: 20,marginTop: 10,marginRight: 10,minHeight: 556}}>
              <h3 className="font-semibold">Performance in Industry</h3>
              <h5 style={{color: '#6B7280',marginBottom: 60}}>Data shows how you are compared to other companies considering your current score</h5>
              <Charts
                config={baseConfig.config}/>
            </Card>
          </Col>
          <Col span={12}>
            <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 60}}>
              <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 0}}>HRA FRESHNESS</h4>
            </Row>
            <Card className="health-check-utilization-card" style={{marginBottom: 20,marginTop: 10,minHeight: 556}} bodyStyle={{padding: 12}}>
              <Row style={{marginBottom: 10}}>
                <Col span={12}>
                  <Card style={{border: 0,backgroundColor: '#FDF1E4',minHeight: 156}}>
                    <h5 className="sub-title">NOT UPDATED</h5>
                    <h2 className="main-numbers" style={{color: '#D97706'}}>{that.state.data.not_updated_in_6months}</h2>
                    <h5 style={{color: '#475569'}}>Employees not updated HRA from past <span className="semibold">6 months</span></h5>
                  </Card>
                </Col>
                <Col span={12}>
                  <Card style={{border: 0,backgroundColor: '#EFF6FF',borderTopLeftRadius: 0,borderBottomLeftRadius: 0,marginLeft: '-2px',minHeight: 156}}>
                    <img src={StarImage} style={{width: '10%',marginBottom: 5}}/>
                    <h5 style={{fontSize: 16,color: '#6B7280'}}>Retaking HRA every <span className="semibold" style={{fontSize: 16,color: '#475569'}}>6 months</span> gives you accurate health data</h5>
                  </Card>
                </Col>
              </Row>
              <Row style={{marginBottom: 10}}>
                <Col span={12}>
                  <Card style={{border: 0,backgroundColor: '#FDEDEB',minHeight: 176}}>
                    <h5 className="sub-title">NOT COMPLETED</h5>
                    <h2 className="main-numbers" style={{color: '#E8432C'}}>{that.state.data.hra_not_completed}</h2>
                    <h5 style={{color: '#475569'}}>Employees didn't complete HRA even once till date</h5>
                  </Card>
                </Col>
                <Col span={12}>
                  <Card style={{border: 0,backgroundColor: '#EFF6FF',borderTopLeftRadius: 0,borderBottomLeftRadius: 0,marginLeft: '-2px',minHeight: 176}}>
                    <img src={StarImage} style={{width: '10%',marginBottom: 5}}/>
                    <h5 style={{fontSize: 16,color: '#6B7280'}}>Employees who completed HRA in <span className="semibold" style={{fontSize: 16,color: '#475569'}}>10 days</span> of registration are tend to be more engaged</h5>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Card style={{border: 0,backgroundColor: '#DDD6FE'}}>
                  <Col span={18}>
                    <h4 className="semibold" style={{fontSize: 20,color: '#5B21B6'}}>Encourage Employees to take HRA which will help us to plan their health journey better</h4>
                    <h5 style={{fontSize: 14,color: '#2563EB'}}>Please reach out to <span className="semibold" style={{color: '#2563EB'}}>{sessionStorage.getItem('hr_contact_email')}</span> to learn more</h5>
                  </Col>
                  <Col span={6}>
                    <Row type="flex" justify="end">
                      <img src={WellnessScoreImage}/>
                    </Row>
                  </Col>
                </Card>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }

  renderWellnessScoreDistribution(){
    let that = this
    return(
      <div>
        <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 60}}>
          <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 0}}>YOUR WELLNESS SCORE DISTRIBUTION BY</h4>
        </Row>
          <Row style={{marginTop: 10}}>
            <Col span={24}>
              <Tabs defaultActiveKey="1" >
                <TabPane tab="Department" key="1">
                  {this.renderChart("department",that.state.data.department_keys,that.state.data.department_current_series,that.state.data.department_goal_series,that.state.data.no_dep)}
                </TabPane>
                <TabPane tab="Location" key="2">
                  {this.renderChart("location",that.state.data.location_keys,that.state.data.location_current_series,that.state.data.location_goal_series,that.state.data.no_loc)}
                </TabPane>
              </Tabs>
            </Col>
          </Row>
      </div>
    )
  }

  renderChart(text,keys,current_series,goal_series,no_data){
    let that = this
    let maxBarsToShow = keys.length > 2 ? 4 : 1
    let showScrollBar = keys.length > 2 ? true : false
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    baseConfig.config.chart.type = 'column'
    baseConfig.config.yAxis.title = {text: "Wellness Score"}
    baseConfig.config.tooltip = {shared: true}
    baseConfig.config.xAxis = {categories: keys,
                                min: 0,
                                max: maxBarsToShow,
                                scrollbar: {enabled: showScrollBar,
                                            barBackgroundColor: '#e8e8e8',
                                            barBorderColor: '#e8e8e8',
                                            barHeight: '15px',
                                            buttonBackgroundColor: '#ffffff',
                                            buttonBorderColor: '#e8e8e8',
                                            backgroundColor: '#F3F4F6'}
                              }

    baseConfig.config.series = [{
        name: 'Goal Score',
        color: '#EFF6FF',
        data: goal_series,
        pointPadding: 0.3,
        states: {
                hover: {
                    enabled: false
                }
            }
    }, {
        name: 'Current Score',
        color: '#2563EB',
        data: current_series,
        pointPadding: 0.4,
        states: {
                hover: {
                    enabled: false
                }
            }
    }]
    baseConfig.config.plotOptions = {column: {
            grouping: false,
            shadow: false,
            borderWidth: 0,
            events: {
            legendItemClick: function () {
                return false;
            }
        }
        }}
    return(
      <div style={{marginTop: 10}}>
        <Card className="health-check-utilization-card" style={{marginBottom: 10,marginTop: 0}}>
          <Charts
            config={baseConfig.config}/>
        </Card>
        <Row type="flex" justify="start">
          <h5 className="health-check-note"><DSIcon name='info' className='mr-1 inline-block align-[-2px] text-amber-700' size={14} />&nbsp;Employees who haven’t provided {text} : <span className="semibold">{no_data}</span></h5>
        </Row>
      </div>
    )
  }

  render () {
    let that = this
    let currentScore = parseInt(that.state.data.current_score).toFixed(0)
    let goalScore = parseInt(that.state.data.goal_score).toFixed(0)
    let interval = goalScore/15
    const overviewLoading   = this.state.loading
    console.log(this.state)
    return(
      <div>
        {(that.state.loading || Object.keys(that.state.data).length === 0 )? <div className="spiner">
          <Spin size="large"/>
        </div> :
        <div>
        <Breadcrumb list={[{ text:'Analytics', link:'#' }, { text:'Wellness score', link:'/wellness-score' }]} classes='mb-1' />
        <Row>
          <Col span={12}>
            <Row type="flex" justify="start">
              <a style={{marginTop: 10}} className="flex flex-row w-full mb-2 items-center" onClick={this.renderOverview.bind(this)}><img className="mt-minus-4 chevronBackLink" style={{marginRight: 5}} src={LeftChevronIcon} /> <span className="GoBackLink" >Go Back</span></a>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Row type="flex" justify="start">
              <h2 className='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl mb-0'>Wellness Score</h2>
            </Row>
          </Col>
          <Col span={12}>
            <Row type="flex" justify="end">
              <img src={WellnessScoreMainImage} alt="wellness" />
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 15}}>
              <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 0,marginTop: 7}}>PRESENT HRA SCORE</h4>
            </Row>
          </Col>
          <Col span={12}>
            <Row type="flex" justify="end" style={{paddingRight: 0,marginTop: 5}}>
              <h4 className="top-right-delay-label" style={{marginTop: 10}}>Refreshes every <b> 1 hour </b></h4>
            </Row>
          </Col>
        </Row>
        <Card className="health-check-utilization-card" style={{marginBottom: 20,marginTop: 10}}>
          <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 15}}>
           {that.state.hraMetricObj && (<h5 className="semibold" style={{color: '#6B7280',marginLeft: 0}}>Employees Completed HRA: <span className="semibold" style={{color: '#2563EB'}}>{that.state.hraMetricObj.hraCompleted}</span> / <span className="semibold" style={{color: '#475569'}}>{that.state.hraMetricObj.totalCustomers}</span></h5>)}
          </Row>
          <svg height="20" width="100%" style={{marginTop: 10}}>
            <text x="2%" y="19" width="65%" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">0%</tspan></text>
            <text x="65%" y="19" width="65%" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">65%</tspan></text>
            <text x="85%" y="19" width="65%" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">85%</tspan></text>
            <text x="100%" y="19" width="65%" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">100%</tspan></text>
          </svg>
          <svg height="120" width="100%">
            <rect x="0" y="5" width="65%" height="120" style={{fill: this.getColor("PoorColor")}} />
            <text x="32.5%" y="25" width="65%" height="120" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#6B7280'}}><tspan dx="-5">Poor</tspan></text>
            <rect x="65%" y="5" width="20%" height="120" style={{fill: this.getColor("AverageColor")}}/>
            <text x="75%" y="25" width="75%" height="120" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#6B7280'}}><tspan dx="25">Average</tspan></text>
            <rect x="85%" y="5" width="15%" height="120" style={{fill: this.getColor("GoodColor")}}/>
            <text x="93%" y="25" width="93%" height="120" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#6B7280'}}><tspan dx="20">Good</tspan></text>
            <text  x={currentScore * 100/goalScore  + '%'} y="85" height="20" letterSpacing="-0.5" style={{textAnchor: "end"}}><tspan dx="-3" className="semibold">{currentScore}</tspan></text>
            <rect  x={currentScore * 100/goalScore  + '%'} y="78" height="20" width="1px" style={{fill: this.getColor("Active")}}/>
            <text  x={currentScore * 100/goalScore  + '%'} y="95" height="20" letterSpacing="-0.5" style={{textAnchor: "end"}}><tspan dx="-3" style={{fontSize: 10}}>Current Score</tspan></text>
            <rect x="0" y="100" width={currentScore * 100/goalScore + '%'} height="12" rx="6" ry="6" style={{fill:this.getColor("Active")}} />
          </svg>
          <svg height="20" width="100%" className="mt-minus-6">
            <text x="1%" y="19" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">0</tspan></text>
            <text x="6.6%" y="19" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">{(interval).toFixed(0)}</tspan></text>
            <text x={parseInt(6.6 * 2) + '%'} y="19" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">{(interval * 2).toFixed(0) }</tspan></text>
            <text x={parseInt(6.6 * 3) + '%'} y="19" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">{(interval * 3).toFixed(0) }</tspan></text>
            <text x={parseInt(6.6 * 4) + '%'} y="19" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">{(interval * 4).toFixed(0) }</tspan></text>
            <text x={parseInt(6.6 * 5) + '%'} y="19" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">{(interval * 5).toFixed(0) }</tspan></text>
            <text x={parseInt(6.6 * 6) + '%'} y="19" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">{(interval * 6).toFixed(0) }</tspan></text>
            <text x={parseInt(6.6 * 7) + '%'} y="19" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">{(interval * 7).toFixed(0) }</tspan></text>
            <text x={parseInt(6.6 * 8) + '%'} y="19" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">{(interval * 8).toFixed(0) }</tspan></text>
            <text x={parseInt(6.6 * 9) + '%'} y="19" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">{(interval * 9).toFixed(0) }</tspan></text>
            <text x={parseInt(6.6 * 10) + '%'} y="19" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">{(interval * 10).toFixed(0) }</tspan></text>
            <text x={parseInt(6.6 * 11) + '%'} y="19" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">{(interval * 11).toFixed(0) }</tspan></text>
            <text x={parseInt(6.6 * 12) + '%'} y="19" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">{(interval * 12).toFixed(0) }</tspan></text>
            <text x={parseInt(6.6 * 13) + '%'} y="19" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">{(interval * 13).toFixed(0) }</tspan></text>
            <text x={parseInt(6.6 * 14) + '%'} y="19" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">{(interval * 14).toFixed(0) }</tspan></text>
            <text x={99.9 + '%'} y="19" height="20" letterSpacing="-0.5" style={{textAnchor: "end", fill: '#9CA3AF'}}><tspan dx="0">{goalScore}</tspan></text>
          </svg>
          <svg height="30" width="100%">
            <text  x={99.9  + '%'} y="13" height="30" letterSpacing="-0.5" style={{textAnchor: "end"}}><tspan dx="-3" className="semibold">{goalScore}</tspan></text>
            <rect  x={99.9  + '%'} y="-2" height="30" width="1px" style={{fill: this.getColor("Active")}}/>
            <text  x={99.9  + '%'} y="26" height="30" letterSpacing="-0.5" style={{textAnchor: "end"}}><tspan dx="-3" style={{fontSize: 10}}>Goal Score</tspan></text>
          </svg>
        </Card>
        {this.renderWellnessScoreTrendChart()}
        {this.renderIndustryWise()}
        {this.renderWellnessScoreDistribution()}
        </div>
        }
      </div>
    )
  }
}
export default CompanyWellnessScore;